// Coalesces rapid, synchronous calls into at most one commit per animation
// frame. Built for the help-chat SSE reader (HelpChatPanel.js): a single
// network read() can carry several `chunk` events, and each one used to call
// setMessages directly - a full re-render (and markdown re-parse) of the
// whole message thread per token, not per frame.
export function createFrameCoalescer(
  commit,
  { raf = requestAnimationFrame, caf = cancelAnimationFrame } = {},
) {
  let frameId = null;
  let pending;

  const schedule = (value) => {
    pending = value;
    if (frameId !== null) return;
    frameId = raf(() => {
      frameId = null;
      const value = pending;
      pending = undefined;
      commit(value);
    });
  };

  const cancel = () => {
    if (frameId !== null) {
      caf(frameId);
      frameId = null;
    }
    pending = undefined;
  };

  // Cancels any pending frame and commits `value` immediately - used when
  // the stream ends or errors, so the final text is guaranteed to land in
  // state right away rather than waiting on a frame that may not fire
  // before the caller flips its own "streaming" flag back off.
  const flushNow = (value) => {
    cancel();
    commit(value);
  };

  return { schedule, cancel, flushNow };
}
